module.exports = __webpack_public_path__ + "static/media/icn-check-green-20px.8c3c08b1.svg";